import moment from 'moment-jalaali';

export const ORDER_STEPS = [
    { id: 2, title: 'تایید فاکتور' },
    { id: 3, title: 'آماده‌سازی و بسته‌بندی' },
    { id: 4, title: 'ارسال به پست' },
    { id: 5, title: 'تحویل به پست' },
    { id: 6, title: 'سفارش‌های نهایی‌شده' },
];

export const getStatusTitleById = (statusId) => {
    const id = parseInt(statusId);
    if (id === 7) return 'ابطال شده';
    const found = ORDER_STEPS.find(s => s.id === id);
    return found ? found.title : 'وضعیت نامشخص';
};

export const getUserRoleInfo = (groupId) => {
    const id = parseInt(groupId);
    switch (id) {
        case 1: return { title: 'فروشنده', className: 'badge-seller' };
        case 2: return { title: 'شما (خریدار)', className: 'badge-buyer' };
        case 3: return { title: 'پشتیبانی', className: 'badge-admin' };
        default: return { title: 'کاربر', className: 'badge-buyer' };
    }
};

export const toPersianDigits = (str) => {
    if (str === null || str === undefined) return '';
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return str.toString().replace(/\d/g, x => farsiDigits[x]);
};

export const formatPrice = (price) => {
    if (price === undefined || price === null) return '0';
    const roundedPrice = Math.round(Number(price));
    if (isNaN(roundedPrice)) return '0';
    return roundedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
        return moment(dateStr).format('HH:mm - jYYYY/jM/jD');
    } catch (e) {
        return dateStr;
    }
};

export const formatShamsiDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return new Intl.DateTimeFormat('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
};

// انتقال مپ کردن دیتا به اینجا برای خلوت شدن کامپوننت اصلی
export const mapApiToUiModel = (apiItem, type) => {
    const isCancelled = type === 'cancelled';
    const isDelivered = type === 'delivered';
    let currentStep = 2;
    if (apiItem.status_id) {
        currentStep = parseInt(apiItem.status_id, 10);
    } else if (isDelivered) {
        currentStep = 6;
    }

    const status = isCancelled ? 'cancelled' : (isDelivered ? 'delivered' : 'normal');

    let formattedDate = '---';
    if (apiItem.date) {
        try {
            formattedDate = moment(apiItem.date).format('jYYYY/jMM/jDD | HH:mm');
        } catch (e) {
            formattedDate = apiItem.date;
        }
    }

    const buyerName = `${apiItem.name_buyer_archive || ''} ${apiItem.family_buyer_archive || ''}`.trim();

    return {
        id: apiItem.id || 0,
        factorNumber: apiItem.factorNumber || '---',
        business_id: apiItem.business_id || apiItem.bussiness_id || apiItem.business?.id,
        shop: apiItem.business?.title || 'فروشگاه نامشخص',
        price: formatPrice(apiItem.total_price_invoice_archive || 0),
        date: formattedDate,
        currentStep: currentStep,
        status: status,
        status_id: apiItem.status_id,
        trackingCodePost: apiItem.trackingCodePost || null,
        supportResponse: null,
        reporters: apiItem.reporters,
        invoice: {
            seller: {
                name: apiItem.business?.title || 'نامشخص',
                phone: '',
                address: ''
            },
            buyer: {
                name: buyerName || 'نامشخص',
                phone: apiItem.mobile_buyer_archive || '',
                address: apiItem.address_buyer_archive || apiItem.address || ''
            },
            items: apiItem.items || [],
            summary: {
                finalPayment: formatPrice(apiItem.total_price_invoice_archive || 0)
            }
        }
    };
};
